import { useTranslation } from "react-i18next";
import { TUseMyBookingRow } from "./MyBookingRow";

export const MbrRefundAction = (jj: TUseMyBookingRow) => {
  const { t } = useTranslation();
  return (
    <aside className="mt-6 space-x-4 text-right">
      <button
        type="button"
        onClick={() => {
          jj.setActionType("");
          jj.setSelectedBookingDetailIds([]);
        }}
        className="ml-auto h-[3.125rem] w-[11.25rem] rounded-[3.4375rem] border border-[#232323] text-base font-semibold leading-[1.25rem] text-[#232323]"
      >
        {t("Close")}
      </button>
      <button
        type="button"
        disabled={jj.selectedBookingDetailIds.length === 0}
        onClick={() => jj.setRefundModalOpen(true)}
        className="ml-auto h-[3.125rem] w-[11.25rem] rounded-[3.4375rem] bg-primary text-base font-semibold leading-[1.25rem] text-[#232323]"
      >
        {t("Next")}
      </button>
    </aside>
  );
};
